export const isMobile = () => $(window).width() < 768;
